import request from "./request";

export const getOrders = async () => {
  const json = await request(`/orders`);
  return json;
};

export const getTransactions = async () => {
  const json = await request(`/orders/transactions`);
  return json;
};

export const getTransactionById = async (transactionId: any) => {
  const json = await request(`/orders/transactions/${transactionId}`);
  return json;
};

export const getOrderCrew = async (crewId: number, baseIds?: number[] | null) => {
  const params = new URLSearchParams();
  baseIds?.forEach((id) => params.append("baseIds", String(id)));
  const queryString = params.toString();
  const url = `/orders/${crewId}${queryString ? `?${queryString}` : ""}`;
  const json = await request(url);
  return json;
};

export const updateOrder = async (orderId: any, newOrder: any) => {
  const response = await request(`/orders/${orderId}`, "PUT", newOrder);

  return response;
};

export const uploadBankFile = async ({ files }: { files: File[] }) => {
  const formData = new FormData();
  for (const file of files) {
    formData.append("file", file);
  }
  const status = await request(`/orders/upload-bank-file`, "POST", formData);
  return status;
};
